import { Routes, RouterModule } from "@angular/router";

import { ExpressIDCardPrintingComponent, PrintComponent } from "./index";
import { AuthguardService } from "../master/services";

export const ExpressIDCardPrintingRoutes: Routes = [
	{ path: "", redirectTo: "/expressidcardprinting/print", pathMatch: "full" },
	{
		path: "print",
		data: { title: "Express ID Card Printing" },
		component: PrintComponent,
		canActivate: [AuthguardService],
	},
];
